import { lerp } from 'three/src/math/MathUtils.js';

export const wrapAround = (
  current: number,
  change: number,
  max: number
): number => {
  const range = max + 1;

  return (((current + change) % range) + range) % range;
};

export const lerpClamp = (
  x: number,
  y: number,
  t: number,
  dt: number = 0.001
) => {
  const lerpedValue = lerp(x, y, t);

  if (Math.abs(lerpedValue - y) <= dt) {
    return y;
  }

  return lerpedValue;
};

export const randomRange = (from: number, to: number) => {
  const min = Math.min(from, to);
  const max = Math.max(from, to);

  return min + Math.random() * (max - min);
};

export const randomRangeInt = (...args: Parameters<typeof randomRange>) =>
  Math.round(randomRange(...args));
